<template>
  <modal
    id="modalCopiarPrecos"
    tamanho="md"
    :titulo="$t('FINANCEIRO.COPIAR_PRECOS')"
    :exibir="exibir"
    :campos="$refs"
    @fechar="fecharModal"
  >
    <div class="container">
      <b-row class="mb-3">
        <b-col md="12">
          <p class="text-muted">
            {{ $t('FINANCEIRO.COPIAR_PRECOS_DESCRICAO') }}
          </p>
        </b-col>
      </b-row>

      <b-row class="mb-3">
        <b-col md="6">
          <input-select
            ref="anoOrigem"
            :options="opcoes.anosLetivos"
            v-model="form.anoOrigemId"
            :label="$t('FINANCEIRO.ANO_ORIGEM')"
            valueField="id"
            textField="ano"
            :required="true"
            @change="validarFormulario"
          />
        </b-col>
        <b-col md="6">
          <input-select
            ref="anoDestino"
            :options="opcoes.anosLetivos"
            v-model="form.anoDestinoId"
            :label="$t('FINANCEIRO.ANO_DESTINO')"
            valueField="id"
            textField="ano"
            :required="true"
            @change="validarFormulario"
          />
        </b-col>
      </b-row>

      <b-row v-if="form.anoOrigemId && form.anoDestinoId && form.anoOrigemId === form.anoDestinoId" class="mb-3">
        <b-col md="12">
          <b-alert variant="warning" show>
            <i class="fas fa-exclamation-triangle"></i>
            {{ $t('FINANCEIRO.ANOS_IGUAIS_AVISO') }}
          </b-alert>
        </b-col>
      </b-row>

      <b-row v-if="form.anoOrigemId && form.anoDestinoId && form.anoOrigemId !== form.anoDestinoId" class="mb-3">
        <b-col md="12">
          <b-alert variant="info" show>
            <i class="fas fa-info-circle"></i>
            {{ $t('FINANCEIRO.COPIAR_PRECOS_CONFIRMACAO', { 
              anoOrigem: getAnoTexto(form.anoOrigemId), 
              anoDestino: getAnoTexto(form.anoDestinoId) 
            }) }}
          </b-alert>
        </b-col>
      </b-row>
    </div>

    <template #modal-footer>
      <div class="w-100 d-flex justify-content-between">
        <b-button variant="secondary" @click="fecharModal">
          {{ $t('GERAL.CANCELAR') }}
        </b-button>
        <b-button 
          variant="primary" 
          @click="copiarPrecos"
          :disabled="!podeCopiar"
        >
          <i class="fas fa-copy mr-1"></i>
          {{ $t('FINANCEIRO.COPIAR_PRECOS') }}
        </b-button>
      </div>
    </template>
  </modal>
</template>

<script>
// Utils & Aux:
import helpers from '@/common/utils/helpers';
import mensagem from '@/common/utils/mensagem';
import { START_LOADING, STOP_LOADING } from '@/store/Store';

// Services:
import AnoLetivoService from '@/common/services/anoLetivo/ano-letivo.service';
import PrecoService from '@/common/services/precos/preco.service';

// Components:
import Modal from '@/components/modal/Modal';
import { InputSelect } from '@/components/inputs/index';

export default {
  props: {
    exibir: { type: Boolean, default: false },
  },
  components: {
    Modal,
    InputSelect,
  },
  data() {
    return {
      refs: [],
      form: {
        anoOrigemId: null,
        anoDestinoId: null,
      },
      opcoes: {
        anosLetivos: [],
      },
    };
  },
  computed: {
    podeCopiar() {
      return this.form.anoOrigemId && 
             this.form.anoDestinoId && 
             this.form.anoOrigemId !== this.form.anoDestinoId;
    },
  },
  mounted() {
    this.getAnosLetivo();
  },
  methods: {
    // FUNÇÕES VALIDAÇÃO FORMULÁRIO:
    validarFormulario() {
      return helpers.validarFormulario(this.refs);
    },
    
    // FUNÇÕES AUXILIARES:
    getAnoTexto(anoId) {
      const ano = this.opcoes.anosLetivos.find(a => a.id === anoId);
      return ano ? ano.ano : '';
    },

    // FUNÇÕES MODAL:
    fecharModal() {
      this.form = {
        anoOrigemId: null,
        anoDestinoId: null,
      };
      this.$emit('fechar');
    },

    async copiarPrecos() {
      if (!this.validarFormulario() || !this.podeCopiar) return;

      const confirmacao = await mensagem.confirmacao(
        this.$t('GERAL.CONFIRMAR'),
        this.$t('FINANCEIRO.COPIAR_PRECOS_CONFIRMACAO_FINAL', {
          anoOrigem: this.getAnoTexto(this.form.anoOrigemId),
          anoDestino: this.getAnoTexto(this.form.anoDestinoId)
        })
      );

      if (!confirmacao.isConfirmed) return;

      this.$store.dispatch(START_LOADING);
      
      try {
        await PrecoService.copiarPrecosDeAnoParaAno({
          anoOrigemId: this.form.anoOrigemId,
          anoDestinoId: this.form.anoDestinoId
        });

        mensagem.sucesso(
          this.$t('GERAL.SUCESSO'),
          this.$t('FINANCEIRO.PRECOS_COPIADOS_SUCESSO')
        );

        this.fecharModal();
        this.$emit('precos-copiados');
      } catch (err) {
        mensagem.showErrors(err);
      } finally {
        this.$store.dispatch(STOP_LOADING);
      }
    },

    getAnosLetivo() {
      AnoLetivoService.listar()
        .then(({ data }) => {
          this.opcoes.anosLetivos = data;
        })
        .catch((err) => {
          mensagem.showErrors(err);
        });
    },
  },
};
</script>
